<template lang="html">
	<div>
		<div :id='data.formId' style="display: none;">
			<div class="form-popup" >
        <p class="title">{{data.header}}</p>
				<label>
					<input type="text" :placeholder='field1.placeholder' v-model='client_name'>

					<span class="validation-error" :error='showRequiredName'>
						<span class="required">{{field1.validator}}</span>
					</span>
				</label>

				<label class="phone">
					<input type="tel"
						:placeholder='field2.placeholder'
						v-model='client_phone'>

					<span class="validation-error" :error='showRequiredPhone'>
						<span class="required">{{field2.validator}}</span>
					</span>
				</label>

				<button @click='click'>{{data.button_2}}</button>

				<grecaptcha
					:request='request'
					:payload='payload'
					@SENDFORM='onRecaptchaSubmit'
				/>
			</div>
		</div>
	</div>
</template>

<script>
const Inputmask = require('inputmask');
module.exports = {
	props: ['data'],

	components: {
		grecaptcha: require('./elements/grecaptcha.vue'),
	},

	data() {
		return {
			uniqueId: new Date().getTime(),
			client_phone: '',
			client_name: '',
      hide_input: '',

			completeName: false,
			completePhone: false,

			showRequiredName: false,
			showRequiredPhone: false,
			grcID: null,

			payload: {}
		}
	},

	computed: {
		field1() {
			return this.data.fields ? this.data.fields[0] : {};
		},
		field2() {
			return this.data.fields ? this.data.fields[1] : {};
		},

		request() {
			return this.data ? this.data.request : {};
		}
	},

	methods: {
		onRecaptchaSubmit(payload) {
			this.$emit('SENDFORM', payload);
		},

		openModal() {
			$.fancybox(`#${this.uniqueId}`, {
				padding: 0,
				beforeShow() {
					// console.log(this.content);
					// this.content[0].classList.add('not-show')
					this.content[0].classList.add('show')
				},
				afterShow() {
					// console.log(this.content);
				},
				beforeClose() {
					this.content[0].classList.remove('not-show')
					this.content[0].classList.remove('show')
				}
			});
		},

		click() {
			if(this.completeName && this.completePhone) {
				this.payload = {
					[this.field1.name]: this.client_name,
					[this.field2.name]: this.client_phone,
          [this.data.nameId]: this.hide_input,
				}
				return this.payload
			}
			else {
				if(!this.completeName) {
					this.showRequiredName = true;
				}
				if(!this.completePhone) {
					this.showRequiredPhone = true;
				}
			}

			// console.log(this.payload);
		}
	},

	watch: {
		client_name() {
			if(this.client_name.length >= 2) {
				this.completeName = true;
				this.showRequiredName = false;
			}
			else {
				this.completeName = false;
			}
		}
	},

	mounted() {
		this.$parent.$on('clear', () => {
			this.client_name = '',
			this.client_phone ='',

			this.completeName = false,
			this.completePhone = false,

			this.showRequiredName = false,
			this.showRequiredPhone = false
		})

		this.$on('clear', () => {
			this.client_phone = this.field2.value;

			console.log(this.field2.value);
		})

		let timerid = setTimeout(() => {
		  this.$emit('clear');
		}, 1000);


		let phone = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.tel.default,
			definitions: {
				'9': '',
				'x': {
					validator: "[0-9\\s]",
					cardinality: 1,
					casing: "lower"
				}
			},
			oncomplete: () => {
				// console.log('oncomplete');
				this.completePhone = true;
				this.showRequiredPhone = false;
			},
			onincomplete: () => {
				this.completePhone = false;
			},
			oncleared: () => {
				this.completePhone = false;
			}
		});

		phone.mask(this.$el.querySelector('.phone input'));

    $("body").on('sliderId', (data) => {
      console.log(data.detail);
      this.hide_input = data.detail;
    });
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";

	.VForm {

		button {
			display: block;
			height: 51px;
			min-width: 120px;
			border-radius: 25px;
			text-decoration: none;
			text-align: center;
			align-items: center;
			justify-content: center;
			font-size: rem(16);
			letter-spacing: .01em;

			@include single-transition();
			@include m___only{
				font-size: rem(14);
			};
			@include l___up {
				font-size: 18px;
			};
		}
	}

	.form-popup {
		width: rem(300);
		padding: rem(30);
		@include single-transition;
		background-color: white;
		border-radius: rem(15);

    .title{
      font-weight: bold;
      font-size: rem(18);
      margin-bottom: 15px;
    }

		button {
			height: rem(60);
			font-size: rem(18);
			color: #de4b39;
			text-decoration: none;
			border: 1px solid #de4b39;
			border-radius: rem(30);
			@include single-transition;
			background-color: #fff;
			margin: 0;
			display: block;

			&:hover {
				background-color: #FF4A35;
				color: #fff;
			}
		}

		&.show {
			opacity: 1;
			@include scale(1);
		}

		[grecaptcha] {
			display: none;
		}

		label {
			display: block;
			width: 100%;
			margin: 0 0 rem(20);
			position: relative;

			input {
				height: rem(61);
				border: 1px solid #989A9E;
				border-radius: rem(30);
				padding: 0 rem(30);
			}

			.validation-error {
				position: absolute;
				left: rem(30);
				right: rem(30);
				font-size: rem(12);
				color: #00B3E9;
				display: block;
				z-index: 1;
				top: calc(100% - 18px);
				text-align: left;

				&[error] .required {
					opacity: 1;
					transform: translateY(0px);
				}

				.required {
					display: block;
					transform: translateY(5px);
					opacity: 0;
					@include single-transition;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// form-popup.vue?40229a28